<template>
    <div class="btn-group">
        <button type="button" @click="save" :disabled="isProcessing" class="btn btn-primary">
            <i class="bi bi-save"></i> Save
        </button>
        <button type="button"
            v-if="loadedInfo.judge.id !== '' && loadedInfo.judge.id !== '00000000-0000-0000-0000-000000000000'"
            @click="prev" :disabled="isProcessing" class="btn btn-secondary">
            <i class="bi bi-arrow-left"></i> Prev
        </button>
        <button @click="next"
            v-if="loadedInfo.judge.id !== '' && loadedInfo.judge.id !== '00000000-0000-0000-0000-000000000000'"
            type="button" :disabled="isProcessing" class="btn btn-secondary">
            Next <i class="bi bi-arrow-right"></i>
        </button>
    </div>
    <div v-if="!isProcessing" class="row">
        <input type="file" id="fileInput" @change="uploadFile" class="d-none" accept="image/*" />
        <form @submit.prevent="saveJudge" id="form-voter-info">
            <div style="text-align: center">
                <div style="text-align: center; position: relative">
                    <div style="position: relative; display: inline-block">
                        <img class="rounded-circle" style="width: 150px; height: 150px; object-fit: cover"
                            id="voter-pic" alt="Profile Picture"
                            :src="loadedInfo.judge.profilePic || 'female-place-holder.jpg'" />

                        <div style="position: absolute; bottom: 0; right: 0">
                            <!-- Add your camera icon here -->
                            <button type="button" id="btn-upload-voter-pic" class="btn btn-secondary">
                                <i class="bi bi-camera" style="font-size: 1.3rem"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-2">
                    <label for="isEnabled" class="form-label">Enabled</label>
                    <div class="form-check form-switch">
                        <input type="checkbox" id="isEnabled" v-model="loadedInfo.judge.isEnabled"
                            class="form-check-input" />
                    </div>
                </div>
                <div class="form-group col-lg-5">
                    <label for="cname">Name:</label>
                    <input class="form-control" v-model="loadedInfo.judge.name" />
                </div>
                <div class="form-group col-lg-5">
                    <label for="cname">Description:</label>
                    <input class="form-control" v-model="loadedInfo.judge.description" />
                </div>

                <div class="form-group">
                    <label for="cname">Code:</label>
                    <div class="input-group">
                        <input :type="passwordVisible ? 'text' : 'password'" class="form-control"
                            v-model="loadedInfo.judge.code" />
                        <button type="button" class="btn btn-sm btn-secondary" @click="togglePasswordVisibility">
                            <i :class="passwordVisible ? 'bi bi-eye-fill' : 'bi bi-eye-slash-fill'"></i>
                        </button>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn btn-primary d-none" id="btnSubmitVoter">
                Save
            </button>
        </form>
    </div>
    <div v-else class="text-center">
        <div class="spinner-border text-danger" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
import spinnerService from "@/services/spinnerService";
import { defineComponent, onMounted, ref, watch, computed } from "vue";
import toastService from "@/services/toastService";
import confirmationService from "@/services/confirmationService";
import { hasRoles } from "@/utils/auth";
import judgeService from "@/services/judgeService";
export default defineComponent({
    props: {
        id: {
            type: String,
            required: true,
            default: () => '',
        },
    },
    emits: ["prev", "next", "reset"],
    setup(props, { emit }) {
        const loadedInfo = ref({
            judge: {},
            groupings: [],
            hhcontent: {},
            logs: [],
        });
        const leaders = ref([]);
        const subleaders = ref([]);
        const hasAccess = ref(false);
        const households = ref([]);
        const cities = ref([]);
        const sectors = ref([]);
        const currentId = ref(0);
        const currentHHId = ref("");
        const brgys = ref([]);
        const pleaders = ref([]);
        const isProcessing = ref(false);
        const hasRequiredRole = (requiredRoles) => {
            return hasRoles(requiredRoles);
        };

        const passwordVisible = ref(false);

        const togglePasswordVisibility = () => {
            passwordVisible.value = !passwordVisible.value;
        };

        const getInfo = async () => {
            if (passwordVisible.value === true) {
                togglePasswordVisibility();
            }
            if (props.id === '' || props.id === null) return;
            if (props.id === '00000000-0000-0000-0000-000000000000') {
                loadedInfo.value = {
                    judge: { id: props.id, isEnabled: true },
                    groupings: [],
                    hhcontent: {},
                    logs: [],
                };
                return;
            }
            isProcessing.value = true;
            loadedInfo.value.judge = await judgeService.getInfo(props.id);
            isProcessing.value = false;
        };


        onMounted(() => {
            getInfo();
        });
        const tabChanged = (tab) => {
            switch (tab) {
                case "groupings":
                    break;
                case "households":
                    break;
                default:
                    break;
            }
        };

        const next = () => {
            emit("next");
        };
        const prev = () => {
            emit("prev");
        };
        const save = () => {
            document.getElementById("btnSubmitVoter").click();
        };
        const saveJudge = async () => {
            if (!hasRequiredRole(["admin", "judge-mod"])) {
                toastService.error("You are not allowed to perform this action");
                return;
            }
            const confirmed = await confirmationService.show(
                "Are you sure you want to save changes?"
            );
            if (!confirmed) return;
            try {
                spinnerService.show();
                const response = await judgeService.saveJudge(loadedInfo.value.judge);
                if (response.success) {
                    toastService.success(response.message);
                    emit("reset");
                } else {
                    toastService.error(response.message);
                }
            } catch (err) {
                toastService.error("An error occured while processing the request.");
            } finally {
                spinnerService.hide();
            }
        };

        const keywordColors = {
            YOUTH: "orange",
            WOMEN: "pink",
            VENDOR: "darkblue",
            FISHER: "gray",
            FARMER: "green",
            TRICYCLE: "brown",
            DEFAULT: "transparent",
        };

        const keywords = ["youth", "women", "vendor", "fisher", "farmer", "tricycle"];

        const getColorForKeyword = (str) => {
            if (str === null) {
                return keywordColors.DEFAULT; // Default color if null is selected
            }
            for (const keyword of keywords) {
                if (str.toUpperCase().includes(keyword.toUpperCase())) {
                    return keywordColors[keyword.toUpperCase()];
                }
            }
            return keywordColors.DEFAULT; // Default color if no keyword is found
        };

        // Computed property to dynamically return the box style based on the selected keyword
        const boxStyle = computed(() => {
            const color = getColorForKeyword(loadedInfo.value.judge.name);
            return {
                backgroundColor: color,
                padding: "20px",
                borderRadius: "8px",
                color: "#333",
                textAlign: "center",
            };
        });

        const newSector = ref(""); // Holds the new value entered by the user
        const isAdding = ref(false);

        const handleAddNewSector = () => {
            isAdding.value = !isAdding.value;
        };


        const handleCancelAdd = () => {
            isAdding.value = false;
        };


        watch(
            () => props.id,
            () => {
                getInfo();
            }
        );


        return {
            loadedInfo,
            leaders,
            subleaders,
            hasAccess,
            households,
            cities,
            brgys,
            isProcessing,
            tabChanged,
            currentId,
            currentHHId,
            prev,
            next,
            save,
            saveJudge,
            hasRequiredRole,
            pleaders,
            sectors,
            newSector,
            handleAddNewSector,
            isAdding,
            handleCancelAdd,
            boxStyle,
            passwordVisible,
            togglePasswordVisibility
        };
    },
});
</script>